(function () {
  function setTooltip(btn, text) {
    const tip = btn.querySelector(".tooltip");
    if (tip) tip.textContent = text;
  }

  async function copyText(text) {
    // Clipboard API (best)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    // Fallback
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".copy-btn");
    if (!btn) return;

    const text = btn.getAttribute("data-copy");
    if (!text) return;

    try {
      await copyText(text);
      setTooltip(btn, "Copied!");
      btn.setAttribute("aria-label", "Copied");
    } catch (err) {
      setTooltip(btn, "Failed");
      btn.setAttribute("aria-label", "Copy failed");
    }

    window.clearTimeout(btn.__copyTimeout);
    btn.__copyTimeout = window.setTimeout(() => {
      setTooltip(btn, "Copy");
      btn.setAttribute("aria-label", "Copy");
    }, 1500);
  });
})();
